import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: [],
  loading: false,
  error: null
};

const schoolNotificationSlice = createSlice({
  name: 'schoolNotification',
  initialState,
  reducers: {
    getSchoolNotifications: () => {},
    getOneSchoolNotification: () => {},
    addSchoolNotification: () => {},
    updateSchoolNotification: () => {},
    removeSchoolNotification: () => {},

    successSchoolNotification: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },
    failedSchoolNotification: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const {
  getSchoolNotifications,
  getOneSchoolNotification,
  addSchoolNotification,
  updateSchoolNotification,
  removeSchoolNotification,
  successSchoolNotification,
  failedSchoolNotification,
  setLoading
} = schoolNotificationSlice.actions;

export default schoolNotificationSlice.reducer;
